(() => {
  const SELECTOR = '.dhc-bis-trigger';

  function sync(root = document) {
    root.querySelectorAll(SELECTOR).forEach((trigger) => {
      const form = trigger.closest('.product-form');
      const addButton = form?.querySelector('[data-add-to-cart-main]');
      if (!addButton) return;
      trigger.style.display = addButton.disabled ? '' : 'none';
    });
  }

  function init() {
    sync();

    const observer = new MutationObserver((mutations) => {
      let shouldSync = false;
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
          shouldSync = true;
          break;
        }
      }
      if (shouldSync) sync();
    });

    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled']
    });

    document.addEventListener('shopify:section:load', (event) => sync(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
